module.exports = __webpack_public_path__ + "img/classes_table.6f9e5bdb.png";